import { DeclineAgendaSlotReservationApiResponse } from '@omecare/utils';
import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

const declineAgendaSlotReservation = (id: string) => {
  return http.agendaSlotReservations.declineById(id);
};

const useDeclineAgendaSlotReservationMutation = (): UseMutationResult<
  DeclineAgendaSlotReservationApiResponse,
  Error,
  string
> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: declineAgendaSlotReservation,
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['office-agenda-slots'] });
      toast.success(t('http.decline-agenda-slot-reservation.success'));
    },
  });
};

export default useDeclineAgendaSlotReservationMutation;
